export default "__VITE_ASSET__9e5009b7__"